import * as cx from 'classnames';
import { COMMENT_DELETED_BY_ADMIN, COMMENT_DELETED_BY_AUTHOR, SHOW } from 'mk/autogenerated/translations/CommentHeader.99ae2ee97ecd9c89119992d9c2581074'
import { getInlinedImages, linebreaksbr, mentionize, replaceImageMarks, urlize } from 'mk/bazaar/common/filters';
import { user_profile_url } from 'mk/urls/functions';
import CommentHeaderName from 'mk2/apps/blogs/components/CommentHeaderName';
import { CommentEntity } from 'mk2/apps/blogs/schemas';
import { CounsellingEntity, PostEntity, PostSchema } from 'mk2/apps/forum/schemas';
import * as urls from 'mk2/apps/forum/urls';
import AvatarImg from 'mk2/components/AvatarImg';
import Btn, { BtnSidePadding, BtnType } from 'mk2/components/Btn';
import { timeAt } from 'mk2/helpers/timeformat';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { url } from 'mk2/helpers/urls';
import { AppState } from 'mk2/reducers';
import { UserEntity } from 'mk2/schemas';
import { createDenormalizedEntitySelector } from 'mk2/selectors';
import * as React from 'react';
import { connect } from 'react-redux';
import styles from './CommentHeader.mscss';

interface OwnProps {
    className?: string;
    comment: CommentEntity;
    isCollapsed: boolean;
    inForum: boolean;
    inGroups?: boolean;
    moderators?: UserEntity[];
    counselling?: CounsellingEntity;

    onToggleDeletedDetails();
}

interface StateProps {
    topicSlug: string;
}

interface DispatchProps {
}

type Props = OwnProps & StateProps & DispatchProps;

class CommentHeader extends React.Component<Props> {

    public render() {
        const {
            className, comment, counselling, inForum, inGroups, isCollapsed, moderators,
            onToggleDeletedDetails, topicSlug,
        } = this.props;

        const showCreateTime = (!comment.deletedAt || (comment.deletedAt && !isCollapsed)) && comment.created && !counselling;
        const showDeletedMessage = comment.deletedAt && isCollapsed;
        const counsellingTopicSlug = counselling && topicSlug ? url(urls.forumTopic, {topicSlug}) : null;

        const useBigAvatar = (inForum && counselling) || inGroups;

        return (inForum || inGroups) ? (
            <div className={cx(styles.CommentHeader, counselling && styles['CommentHeader--counsellingHeader'], className)}>
                <AvatarImg
                    size={useBigAvatar ? 32 : 24}
                    user={comment.authorUser}
                    href={counselling ? counsellingTopicSlug : user_profile_url(comment.authorUser.username)}
                    counsellorAvatar={counselling ? counselling.counsellorAvatar : null}
                    className={inGroups && styles['CommentHeader__avatarImg--inGroups']}
                />

                {inGroups ? (
                    <div>
                        <div className={styles.CommentHeader__firstline}>
                            <CommentHeaderName
                                comment={comment}
                                inForum={inForum}
                                inGroups={inGroups}
                                moderators={moderators}
                                counselling={counselling}
                                topicSlug={topicSlug}
                            />

                            {showDeletedMessage && (
                                <div>
                                    &nbsp;&nbsp;&bull;&nbsp;&nbsp;
                                    {comment.deletedByAuthor ? COMMENT_DELETED_BY_AUTHOR : COMMENT_DELETED_BY_ADMIN}
                                    &nbsp;&nbsp;&bull;&nbsp;&nbsp;

                                    <Btn
                                        key="deleted-btn"
                                        onClick={onToggleDeletedDetails}
                                        label={SHOW}
                                        sidePadding={BtnSidePadding.None}
                                        type={BtnType.BlueTextLight}
                                        classNames={{label: styles.CommentHeader__deletedBtnLabel}}
                                    />
                                </div>
                            )}
                        </div>
                        <div>
                            {showCreateTime && timeAt(comment.created)}
                        </div>
                    </div>
                ) : [
                    <CommentHeaderName
                        key="name"
                        comment={comment}
                        inForum={inForum}
                        inGroups={inGroups}
                        moderators={moderators}
                        counselling={counselling}
                        topicSlug={topicSlug}
                    />,

                    showCreateTime && [
                        <div key="created-sep" className={styles.CommentHeader__sep}>•</div>,
                        <span key="created">
                            {timeAt(comment.created)}
                        </span>,
                    ],

                    showDeletedMessage && [
                        <div key="deleted-sep" className={styles.CommentHeader__sep}>•</div>,
                        <div key="deleted-message">
                            {comment.deletedByAuthor ? COMMENT_DELETED_BY_AUTHOR : COMMENT_DELETED_BY_ADMIN}
                        </div>,
                        <div key="deleted-sep2" className={styles.CommentHeader__sep}>•</div>,
                        <Btn
                            key="deleted-btn"
                            onClick={onToggleDeletedDetails}
                            label={SHOW}
                            sidePadding={BtnSidePadding.None}
                            type={BtnType.BlueTextLight}
                            classNames={{label: styles.CommentHeader__deletedBtnLabel}}
                        />,
                    ],
                ]}
            </div>
        ) : (
            <div className={styles.CommentHeader}>
                <AvatarImg
                    size={32}
                    user={comment.authorUser}
                    className={styles.CommentHeader__blogsAvatar}
                    href={user_profile_url(comment.authorUser.username)}
                />
            </div>
        );
    }

}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    const { comment } = ownProps;

    const getTopicSlug = (postId) => {
        const post: PostEntity = createDenormalizedEntitySelector<PostEntity>()(state, PostSchema, postId);
        return post ? post.topic.slug : null;
    };

    const topicSlug = getTopicSlug(comment.postId);
    return {
        topicSlug,
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
};

export default connect(mapStateToProps, mapDispatchToProps)(CommentHeader);
